import { createFileRoute } from "@tanstack/react-router";
import { HomePage } from "@/components/pages/HomePage";
import { ROUTE_META } from "@/i18n/route-meta";
import heroWebp from "@/assets/kentro-fluid-hero-4x3.webp.asset.json";

const SITE = "https://kentro.com.br";
const OG_IMAGE = `${SITE}${heroWebp.url}`;

export const Route = createFileRoute("/$locale/")({
  head: ({ params }) => {
    const loc = params.locale === "es" ? "es" : "en";
    const d = ROUTE_META[loc];
    const ogLocale = loc === "es" ? "es_ES" : "en_US";
    return {
      meta: [
        { title: d.home.metaTitle },
        { name: "description", content: d.home.metaDesc },
        { property: "og:title", content: d.home.metaTitle },
        { property: "og:description", content: d.home.metaDesc },
        { property: "og:url", content: `${SITE}/${loc}` },
        { property: "og:locale", content: ogLocale },
        { property: "og:image", content: OG_IMAGE },
        { property: "og:image:width", content: "1200" },
        { property: "og:image:height", content: "900" },
        { property: "og:image:alt", content: d.home.mockupTitle },
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:image", content: OG_IMAGE },
      ],
      links: [
        { rel: "canonical", href: `${SITE}/${loc}` },
        { rel: "alternate", hrefLang: "pt-BR", href: `${SITE}/` },
        { rel: "alternate", hrefLang: "en", href: `${SITE}/en` },
        { rel: "alternate", hrefLang: "es", href: `${SITE}/es` },
        { rel: "alternate", hrefLang: "x-default", href: `${SITE}/` },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              { "@type": "ListItem", position: 1, name: loc === "es" ? "Inicio" : "Home", item: `${SITE}/${loc}/` },
              { "@type": "ListItem", position: 2, name: 'Home', item: `${SITE}/${loc}/` },
            ],
          }),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": 'WebPage',
            "@id": `${SITE}/${loc}/`,
            url: `${SITE}/${loc}/`,
            name: d.home.metaTitle,
            description: d.home.metaDesc,
            inLanguage: loc === "es" ? "es" : "en",
            isPartOf: { "@type": "WebSite", "@id": `${SITE}/#website` },
          }),
        },
      ],
    };
  },
  component: HomePage,
});
